export default __webpack_public_path__ + "static/media/logo-text.6e051b41.png";